import React from 'react';
import { FC } from 'react';
import { Helmet } from 'react-helmet';

interface HeadProps {
  title: string;
  description: string;
}

export const Head: FC<HeadProps> = ({ title, description }) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
    </Helmet>
  );
};
